module.exports = __webpack_public_path__ + "static/media/mobileScreenshot05.b876f4d0.jpg";